module.exports = __webpack_public_path__ + "3f16e137/img/rename-icon.de4e673d.svg";